var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconVersion = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M27.4,6.3v17.3c0,1.2-1,2.2-2.2,2.2H14.4c-1.2,0-2.2-1-2.2-2.2V6.3c0-1.2,1-2.2,2.2-2.2h10.8\n                        C26.4,4.2,27.4,5.1,27.4,6.3z" }),
                React.createElement("path", { d: "M9.6,22.9L9.6,22.9c-1.2,0-2.2-1-2.2-2.2V9.3c0-1.2,1-2.2,2.2-2.2l0,0" }),
                React.createElement("path", { d: "M4.8,21.2L4.8,21.2c-1.2,0-2.2-1-2.2-2.2v-7.7c0-1.2,1-2.2,2.2-2.2l0,0" })))));
});
export default IconVersion;
//# sourceMappingURL=IconVersion.js.map